export default __webpack_public_path__ + "static/media/focus-rs-full.f223ef0e.png";